import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "lorenPlanTimePeriodConverter",
  standalone: true,
})
export class LorenPlanTimePeriodConverterPipe implements PipeTransform {
  transform(value: number): string {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    return `${hours < 10 ? "0" + hours : hours}:${
      minutes < 10 ? "0" + minutes : minutes
    }`;
  }
}
